// i18n area 'backups' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da archive.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/backups.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './backups'

export const enGB: DeepPartial<typeof enUS> = {
  ckpt: {
    storageHint: 'A dir-like storage (dir/NFS/CIFS/CephFS) — the artefacts are plain files under the platform namespace.',
    restoreHint: 'Upload a .tvbk artefact: the explorer shows what it carries, then you choose what to restore and how.',
    uploadFailed: 'The artefact could not be opened',
    rescanHint:
      'Rebuilds the backup catalogue (VM/CT/App) from the manifests of the artefacts on this destination. Existing rows are never touched; backups of unknown policies stay orphans (never pruned automatically). The move after a bootstrap restore.'
  },
  backup: {
    intro: {
      whatItIsNot:
        'TVirt is not a backup product: it schedules nothing, retains nothing and stores no archive of your data. Retention, catalogues and restore policies belong to the software you already use.'
    }
  }
}
